module.exports = __webpack_public_path__ + "img/JielongYan.ee450b86.jpg";